"use strict";

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
import mobileMenu from './modules/mobileMenu';
import siteWide from './modules/siteWide'; 


document.addEventListener("DOMContentLoaded", () => {
	const currentUrl = window.location.href;
	const menuItems = document.querySelectorAll(".navbar__nav li");

	menuItems.forEach((item) => {
		const menuItemLink = item.querySelector("a");

		if (menuItemLink && menuItemLink.href === currentUrl) {
			let parent = item;
			while (parent) {
				if (parent.tagName === "LI") {
					parent.classList.add("item-active");
				}
				parent = parent.parentElement.closest(".navbar__nav li");
			}
		}

		const subMenuLinks = item.querySelectorAll(".sub-menu a");
		if (subMenuLinks.length > 0) {
			subMenuLinks.forEach((subMenuItem) => {
				subMenuItem.addEventListener("click", (e) => {
					const parentItem = e.target.closest(".navbar__nav li");
					if (parentItem) {
						let parent = parentItem;
						while (parent) {
							if (parent.tagName === "LI") {
								parent.classList.add("item-active");
							}
							parent =
								parent.parentElement.closest(".navbar__nav li");
						}
					}
				});
			});
		}
	});

});
